import { type TApiResponse } from '../models';

export const extractResponse = (res: TApiResponse<any>) => res?.data?.data;
